<div class="flex w-full flex-col gap-2">
  @for (topicArea of productDataService.topicAreas(); track topicArea.id) {
    <app-topic-area-card
      [title]="topicArea.name"
      [selected]="isCardSelected(topicArea.id)"
      [preselected]="preselected"
      [disabled]="disabled"
      [trialing]="isCardTrialing(topicArea.id)"
      (cardClick)="onCardSelect(topicArea.id)"
    />
  }
</div>
